export default {
  SET_GROUPS: (state, data) => {
    state.groups = data;
  },
  SET_GROUP: (state, data) => {
    state.group = data;
  },
};
